import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

export default function BannerButton ({url, data }) {

  const isExternalUrl = url.startsWith('http');


  return (
    <>
      {isExternalUrl ?
        <a
          style={{
            backgroundColor: data.btncolor,
            borderRadius: data.buttonBorder || '',
            fontWeight: data.buttonFontStyle?.indexOf('bold') >= 0 ? 'bold' : '',
            textDecoration: data.buttonFontStyle?.indexOf('underline') >= 0 ? 'underline' : '',
            textDecorationColor: data.buttonTextColor,
            fontSize: `${data.buttonFontSize || ''}px`,
          }}
          className={`animated dtn_over${data?._id} ${data.btnAnimationDelay} ${data.btnAnimationName}`}
          href={process.env.PUBLIC_URL + data.buttonUrl}
          target="_blank"
        >
          <span style={{ color: data.buttonTextColor }} >{data.buttonText}</span>

        </a>
        :
        <Link
          style={{
            backgroundColor: data.btncolor,
            borderRadius: data.buttonBorder || '',
            fontWeight: data.buttonFontStyle?.indexOf('bold') >= 0 ? 'bold' : '',
            textDecoration: data.buttonFontStyle?.indexOf('underline') >= 0 ? 'underline' : '',
            textDecorationColor: data.buttonTextColor,
            fontSize: `${data.buttonFontSize || ''}px`,
          }}
          className={`animated dtn_over${data?._id} ${data.btnAnimationDelay} ${data.btnAnimationName}`}
          to={process.env.PUBLIC_URL + data.buttonUrl}
        >
          <span style={{ color: data.buttonTextColor }} >{data.buttonText}</span>

        </Link>
      }
    </>
  );
}
